<div class="status-filter-wrapper">
  <!-- Trigger Button (Matching Expense filter-button UI) -->
  <button
    mat-flat-button
    type="button"
    class="new-sorting-btn start-sm-0"
    [matMenuTriggerFor]="filterMenu"
    [ngClass]="{ active: isFilterApplied }"
    (click)="onTriggerClick()"
  >
    <div class="d-flex align-items-center">
      <div class="filter-icon-box" (click)="onIconClick($event)">
        <img src="assets/images/plus-circle.svg" alt="filter" />
      </div>

      <span class="ms-2">
        {{ resolvedLabel }} <span *ngIf="isFilterApplied">| </span>
      </span>

      <h6 class="m-0 ms-1" *ngIf="isFilterApplied">
        {{ displaySelectedLabel }}
      </h6>
    </div>
  </button>

  <!-- MatMenu Popover (Exact Expense popover styling) -->
  <mat-menu #filterMenu="matMenu" class="status-filter-menu-panel mt-1" xPosition="before" (menuOpened)="onMenuOpened()">
    <div
      class="status-filter-popover"
      (click)="$event.stopPropagation()"
    >
      <p class="status-filter-title">
        {{ effectivePopoverTitle }}
      </p>

      <!-- Search in options (Enabled by default matching Expense) -->
      <div *ngIf="!hideSearch" class="status-filter-search">
        <div class="status-search-box">
          <svg class="status-search-icon" width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z" stroke="#94a3b8" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M17.5 17.5L13.875 13.875" stroke="#94a3b8" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <input
            type="text"
            class="status-search-input"
            [(ngModel)]="searchText"
            [placeholder]="effectiveSearchPlaceholder"
            (click)="$event.stopPropagation()"
          />
          <button
            type="button"
            *ngIf="searchText"
            class="status-search-clear"
            (click)="searchText = ''; $event.stopPropagation()"
          >
            &times;
          </button>
        </div>
      </div>

      <!-- Options List using unified app-checkbox -->
      <div class="status-options-list">
        <div
          *ngFor="let opt of filteredOptions"
          class="status-option-item"
          (click)="toggleOption(opt.value, $event)"
        >
          <app-checkbox
            [checked]="isSelected(opt.value)"
            [labelText]="opt.label"
            (click)="$event.stopPropagation()"
            (checkboxChange)="toggleOption(opt.value)"
          ></app-checkbox>
        </div>
        <div
          *ngIf="filteredOptions.length === 0"
          class="status-no-options"
        >
          No match found
        </div>
      </div>

      <!-- Action Button (Apply matching Expense) -->
      <div class="status-filter-actions">
        <app-primary-button
          label="Apply"
          size="medium"
          [fullWidth]="true"
          (btnClick)="applyFilter($event)"
        ></app-primary-button>
      </div>
    </div>
  </mat-menu>
</div>
